import React from 'react'

const Manual_shogo_conexion_ingles = () => {
  return (
    <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-10">
      <div className="mt-16">
        <h2 className="font-bold text-4xl text-[#002D33] mb-5">Shogo - Conexión en Inglés</h2>
        <iframe
          src="https://scribehow.com/embed/Shogo__Conexion_en_Ingles__vLd5W_fLSkqd8JytCOUo0Q?as=scrollable"
          className="scribe-iframe-general-186"
          width="100%"
          height="800"
          allowFullScreen
          style={{ border: 0, minHeight: '640px' }}
        ></iframe>
      </div>
    </div>
  )
}

export default Manual_shogo_conexion_ingles
